export enum ASSET_TYPE {
  PROPERTY = 'PROPERTY',
  VEHICLE = 'VEHICLE',
  HOME_CONTENTS = 'HOME_CONTENTS',
  SAVING_CHECK_ACCOUNT = 'SAVING_CHECK_ACCOUNT',
  SUPERANNUATION = 'SUPERANNUATION',
  TERM_DEPOSIT = 'TERM_DEPOSIT',
  SHARES = 'SHARES',
  MANAGED_FUNDS = 'MANAGED_FUNDS',
  GIFTS = 'GIFTS',
  OTHER_ASSET = 'OTHER_ASSET',
}

export enum STATE {
  ACT = 'ACT',
  NSW = 'NSW',
  NT = 'NT',
  QLD = 'QLD',
  SA = 'SA',
  TAS = 'TAS',
  VIC = 'VIC',
  WA = 'WA',
}

export enum CONSTRUCTION_TYPE {
  STRUCTURAL_RENOVATIONS = 'STRUCTURAL_RENOVATIONS',
  BUILD_A_PROPERTY = 'BUILD_A_PROPERTY',
  KNOCKDOWN_REBUILD = 'KNOCKDOWN_REBUILD',
}

export enum BUILDER_TYPE {
  LICENSED_BUILDER = 'LICENSED_BUILDER',
  OWNER_BUILDER = 'OWNER_BUILDER',
}
